import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import {
  InterviewGraphWrapper,
  ArrowLine,
  Arrow,
  InterviewGraph,
  GraphColumn,
  InterviewGraphTooltip,
} from "./styles/company-performance-styles";

const InterviewRateGraph = ({ interviewRate, isEmployer }) => {
  const arrowPosition = (rate) => {
    if (rate >= 60) {
      return 100;
    }
    return rate / 0.6;
  };

  const handleLabel = (rate) => {
    if (rate >= 11 && rate < 21) return "Average";
    if (rate >= 21 && rate < 31) return "Good";
    if (rate >= 31 && rate < 41) return "Very Good";
    if (rate >= 41 && rate < 51) return "Excellent";
    if (rate >= 51) return "Outstanding";
    return "Satisfactory";
  };

  const agencyTooltipText =
    "<strong><u>Interview Rate Scale</u></strong><br><br>This quality scale is designed to give you<br>an idea of how you are performing relative<br>to other HH agencies. This scale looks at all<br>active agencies and marks your score between<br>the highest and lowest interview rates. This<br>scale will change as agencies work on HH and<br>your pointer on the scale will change as a result.";

  const employerTooltipText =
    "<strong><u>Interview Rate Scale</u></strong><br><br>This scale is designed to give you a better<br>idea of the quality of each agency working<br>on Hiring Hub. A good interview rate score<br>is 30% or higher.";

  return (
    <InterviewGraphWrapper data-test-id="interview-rate-graph">
      <ArrowLine>
        <Arrow
          position={arrowPosition(interviewRate)}
          label={handleLabel(interviewRate)}
        />
      </ArrowLine>
      <ReactTooltip
        html
        place="left"
        type="dark"
        effect="float"
        aria-haspopup="true"
        id="company-performance-graph-tooltip"
      />
      <InterviewGraph
        data-for="company-performance-graph-tooltip"
        data-tip={isEmployer ? employerTooltipText : agencyTooltipText}
      >
        <GraphColumn backgroundColor="#ffb124" />
        <GraphColumn backgroundColor="#fff830" />
        <GraphColumn backgroundColor="#27ae60" />
        <InterviewGraphTooltip>
          <FontAwesomeIcon icon={faInfoCircle} />
        </InterviewGraphTooltip>
      </InterviewGraph>
    </InterviewGraphWrapper>
  );
};

InterviewRateGraph.propTypes = {
  interviewRate: PropTypes.number,
  isEmployer: PropTypes.bool.isRequired,
};

InterviewRateGraph.defaultProps = {
  interviewRate: PropTypes.isNull,
};

export default InterviewRateGraph;
